import Wrapper from './_views/Wrapper.vue';

const parentRouteConfig = {
  name: 'Input Messages',
  to: {
    name: 'inputMessages',
    query: {
      pageNum: '1',
      suffix: '',
    },
  },
};

export default {
  path: '/input-messages',
  component: Wrapper,
  children: [
    {
      path: '',
      name: 'inputMessages',
      component: () => import(/* webpackChunkName: "pressSheets" */ './_views/KernelInputMessages.vue'),
      meta: {
        title: 'Input Messages',
        navigation: {
          position: 7,
          name: 'Input Messages',
          icon: 'email',
          specialQueries: ['suffix'],
          to: {
            name: 'inputMessages',
            query: {
              suffix: '',
              pageNum: '1',
            },
          },
        },
      },
    },
    {
      path: ':id',
      name: 'inputMessage',
      component: () => import(/* webpackChunkName: "pressSheet" */ './_views/KernelInputMessage.vue'),
      meta: {
        title: 'Input Message',
        parent: parentRouteConfig,
      },
    },
  ],
};
